// ─── ROUTER & DATA DEALS ───────────────────────────────────────────────────
// To add images: replace null with your image URL

export const ROUTER_DATA = [
  // ── HOME INTERNET (CONTRACT) ──────────────────────────────────────────────
  {
    id: 1, category: 'Home Internet', brand: 'Vodacom',
    name: 'Vodacom 5G Router', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: null,
    package: 'Home Internet 10Mbps', data: '200GB FUP', minutes: null, onceOff: null,
    speed: 'UP TO 10Mbps', price: 399, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 2, category: 'Home Internet', brand: 'Vodacom',
    name: 'Vodacom 5G Router', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: 'POPULAR',
    package: 'Home Internet 20Mbps', data: '400GB FUP', minutes: null, onceOff: null,
    speed: 'UP TO 20Mbps', price: 429, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 3, category: 'Home Internet', brand: 'Vodacom',
    name: 'Vodacom 5G Router', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: null,
    package: 'Home Internet 30Mbps', data: '600GB FUP', minutes: null, onceOff: null,
    speed: 'UP TO 30Mbps', price: 499, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 4, category: 'Home Internet', brand: 'Vodacom',
    name: 'Vodacom 5G Router', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: null,
    package: 'Home Internet 50Mbps', data: '1TB FUP', minutes: null, onceOff: null,
    speed: 'UP TO 50Mbps', price: 599, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 5, category: 'Home Internet', brand: 'Vodacom',
    name: 'Vodacom 5G Router', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: null,
    package: 'Home Internet 100Mbps', data: '2TB FUP', minutes: null, onceOff: null,
    speed: 'UP TO 100Mbps', price: 699, wasPrice: null, save: null, term: 36, prepaid: null,
  },

  // ── PREPAID HOME INTERNET ─────────────────────────────────────────────────
  {
    id: 6, category: 'Prepaid Internet', brand: 'Vodacom',
    name: 'Vodacom C200 5G Router — Bundle', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: null,
    package: 'Prepaid 100GB', data: '100GB', minutes: null, onceOff: null,
    speed: null, price: 99, wasPrice: null, save: null, term: null, prepaid: 999,
    note: '7-Day Bundle. Router R999 once-off',
  },
  {
    id: 7, category: 'Prepaid Internet', brand: 'Vodacom',
    name: 'Vodacom C200 5G Router — Bundle', storage: null,
    image: null,                   // ← ADD ROUTER IMAGE URL HERE
    badge: null,
    package: 'Prepaid 400GB', data: '400GB', minutes: null, onceOff: null,
    speed: null, price: 399, wasPrice: null, save: null, term: null, prepaid: 999,
    note: '30-Day Bundle. Router R999 once-off',
  },

  // ── SIM-ONLY RED FLEXI ────────────────────────────────────────────────────
  {
    id: 10, category: 'SIM-Only', brand: 'Vodacom',
    name: 'RED FLEXI 170', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 170', data: '170 Airtime Value', minutes: null, onceOff: '30GB',
    speed: null, price: 149, wasPrice: null, save: null, term: 24, prepaid: null,
  },
  {
    id: 11, category: 'SIM-Only', brand: 'Vodacom',
    name: 'RED FLEXI 245', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 245', data: '245 Airtime Value', minutes: null, onceOff: '30GB',
    speed: null, price: 199, wasPrice: null, save: null, term: 24, prepaid: null,
  },
  {
    id: 12, category: 'SIM-Only', brand: 'Vodacom',
    name: 'RED FLEXI 320', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 320', data: '320 Airtime Value', minutes: null, onceOff: '30GB',
    speed: null, price: 269, wasPrice: null, save: null, term: 24, prepaid: null,
  },

  // ── SIM-ONLY RED CORE ─────────────────────────────────────────────────────
  {
    id: 13, category: 'SIM-Only', brand: 'Vodacom',
    name: '3GB RED CORE', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    speed: null, price: 279, wasPrice: null, save: null, term: 24, prepaid: null,
  },
  {
    id: 14, category: 'SIM-Only', brand: 'Vodacom',
    name: '6GB RED CORE', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    speed: null, price: 449, wasPrice: null, save: null, term: 24, prepaid: null,
  },
  {
    id: 15, category: 'SIM-Only', brand: 'Vodacom',
    name: '12GB RED CORE', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED 12GB CORE', data: '12GB Anytime', minutes: '750', onceOff: '30GB',
    speed: null, price: 699, wasPrice: null, save: null, term: 24, prepaid: null,
  },

  // ── SIM-ONLY RED VIP ──────────────────────────────────────────────────────
  {
    id: 16, category: 'SIM-Only', brand: 'Vodacom',
    name: 'RED VIP 100GB', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED VIP 100GB', data: '50GB Anytime + 50GB Night Owl', minutes: null, onceOff: '30GB',
    speed: null, price: 1299, wasPrice: null, save: null, term: 24, prepaid: null,
  },
  {
    id: 17, category: 'SIM-Only', brand: 'Vodacom',
    name: 'RED VIP 200GB', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED VIP 200GB', data: '100GB Anytime + 100GB Night Owl', minutes: null, onceOff: '30GB',
    speed: null, price: 1799, wasPrice: null, save: null, term: 24, prepaid: null,
  },
  {
    id: 18, category: 'SIM-Only', brand: 'Vodacom',
    name: 'RED VIP 400GB', storage: null,
    image: null,                   // ← ADD SIM CARD IMAGE URL HERE
    badge: null,
    package: 'RED VIP 400GB', data: '200GB Anytime + 200GB Night Owl', minutes: null, onceOff: '30GB',
    speed: null, price: 2099, wasPrice: null, save: null, term: 24, prepaid: null,
  },

  // ── PREPAID DATA BUNDLES ──────────────────────────────────────────────────
  {
    id: 20, category: 'Prepaid Data', brand: 'Vodacom',
    name: '6GB Prepaid Bundle', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Prepaid', data: '3GB Anytime + 3GB Night Owl', minutes: null, onceOff: null,
    speed: null, price: 49, wasPrice: null, save: null, term: null, note: 'Valid 14 days',
  },
  {
    id: 21, category: 'Prepaid Data', brand: 'Vodacom',
    name: '10GB Prepaid Bundle', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Prepaid', data: '5GB Anytime + 5GB Night Owl', minutes: null, onceOff: null,
    speed: null, price: 49, wasPrice: null, save: null, term: null, note: 'Valid 7 days',
  },
  {
    id: 22, category: 'Prepaid Data', brand: 'Vodacom',
    name: '30GB Prepaid Bundle', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Prepaid', data: '15GB Anytime + 15GB Night Owl', minutes: null, onceOff: null,
    speed: null, price: 149, wasPrice: null, save: null, term: null, note: 'Valid 30 days',
  },
  {
    id: 23, category: 'Prepaid Data', brand: 'Vodacom',
    name: '60GB Prepaid Bundle', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Prepaid', data: '30GB Anytime + 30GB Night Owl', minutes: null, onceOff: null,
    speed: null, price: 249, wasPrice: null, save: null, term: null, note: 'Valid 30 days',
  },
  {
    id: 24, category: 'Prepaid Data', brand: 'Vodacom',
    name: '150GB Prepaid Bundle', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Prepaid', data: '75GB Anytime + 75GB Night Owl', minutes: null, onceOff: null,
    speed: null, price: 399, wasPrice: null, save: null, term: null, note: 'Valid 30 days',
  },
  {
    id: 25, category: 'Prepaid Data', brand: 'Vodacom',
    name: '300GB Prepaid Bundle', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'Prepaid', data: '150GB Anytime + 150GB Night Owl', minutes: null, onceOff: null,
    speed: null, price: 499, wasPrice: null, save: null, term: null, note: 'Valid 30 days',
  },
];

export const ROUTER_CATEGORIES = ['All', 'Home Internet', 'Prepaid Internet', 'SIM-Only', 'Prepaid Data'];
